export class IziviaError extends Error {
    ignoreErrorReporting: boolean; // permit to not notify sentry
    constructor(message: any, ignoreErrorReporting?: boolean) {
        if (typeof message === 'string') {
            super(message);
        } else {
            super(JSON.stringify(message));
        }

        this.ignoreErrorReporting = ignoreErrorReporting;
    }
}
